import React, { useState } from 'react';

import { VerificationCardPin } from './components/VerificationCardPin';

import { ManagedPopup } from 'js/components/common/Popup';
import { useOnClose } from 'js/components/common/PopupManager';

import { useTranslations } from 'js/hooks/i18n';

import style from './VerificationCardPinPopup.scss';

export const VerificationCardPinPopup = ({ id }) => {
    const [isShowDoneState, setIsShowDoneState] = useState(false);

    const closePopup = useOnClose(id);
    const translate = useTranslations('playtech.mobile.system.verifycardpin.');

    return (
        <ManagedPopup
            isModal
            withLogo
            className={style.popup}
            title={translate(`popup.title${isShowDoneState ? '.success' : ''}`)}
        >
            <VerificationCardPin
                closePopup={closePopup}
                isShowDoneState={isShowDoneState}
                setIsShowDoneState={setIsShowDoneState}
            />
        </ManagedPopup>
    );
};
